import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colors } from '../../../../constants/colors';
import { fontFamily, fontSize } from '../../../../constants/text';
import { safeGet } from '../../../../core/util/object';
import { pluralize } from '../../../../core/util/string';

const Root = styled.div`
  color: ${colors.blueMonday};
  font-size: ${fontSize.mediumSmall};
  line-height: 21px;
  font-family: ${fontFamily.book};
  display: flex;
  flex-direction: row;
`;

class RecentlyBookedCopy extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
  };

  render() {
    const recentBookings = safeGet(this.props.location)('recentBookings');
    return (
      <Root>
        Booked on Solv {recentBookings} {pluralize(recentBookings, 'time')} today
      </Root>
    );
  }
}

export default RecentlyBookedCopy;
